import APIClient from './index';
import _ from 'lodash';

export const getAllIndustries = () => {
  return new Promise((resolve, reject) => {
    APIClient.get('Industries')
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
